import { VerifyEmailForm } from "@/components/auth";
import { useVerifyEmail, useResendOtp } from "@/api/mutation";
import { VerifyEmailDTO } from "@/api/types";

export const VerifyEmail = () => {
  const { mutate: verifyEmail, isPending: isVerifying } = useVerifyEmail();
  const { mutate: resendOtp, isPending: isResending } = useResendOtp();

  const handleVerifyEmail = async (data: VerifyEmailDTO) => {
    try {
      verifyEmail(data);
    } catch (error) {
      console.error("Email verification error:", error);
    }
  };

  const handleResendOtp = async () => {
    try {
      // Get email from localStorage
      const email = localStorage.getItem("pendingVerificationEmail");
      // Get usage type from localStorage (defaults to VERIFY_EMAIL for backward compatibility)
      const usage = localStorage.getItem("verificationUsage") || "VERIFY_EMAIL";

      if (email) {
        resendOtp({
          email,
          usage: usage as "VERIFY_EMAIL" | "RESET_PASSWORD",
        });
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
    }
  };

  return (
    <VerifyEmailForm
      onSubmit={handleVerifyEmail}
      onResendOtp={handleResendOtp}
      isPending={isVerifying}
      isResending={isResending}
    />
  );
};
